import { Button, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalSettlementHistory extends Layout {
    buttonSearch: Button;
    labelTitle: Label;
    panelPageTitle: Panel;
    sourceSettlement: DataSource;
    tableSettlement: Table;
    textboxCarrierProNbr: Textbox;
    textboxCheckNumber: Textbox;
    textboxDeliveryDate: Textbox;
    textboxOrderId: Textbox;
    textboxPayDate: Textbox;
}
